import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/* Auto-generated. Do not edit! */
/* eslint-disable */

const SvgBr = props => /*#__PURE__*/_jsxs("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  fill: "rgb(0 0 0 / 60%)",
  ...props,
  children: [/*#__PURE__*/_jsxs("g", {
    clipPath: "url(#a)",
    children: [/*#__PURE__*/_jsx("circle", {
      cx: 12,
      cy: 12,
      r: 12,
      fill: "#229E45"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#FFE62E",
      d: "M23.809 9.857a12.1 12.1 0 0 1 0 4.285L12 20.066.19 14.142a12.1 12.1 0 0 1 0-4.285L12 3.934z"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#2B49A3",
      d: "M9.6 10.577c3.28 0 6.16 1.803 7.64 4.407-1.04 1.803-3 3.045-5.24 3.045-3.32 0-6-2.684-6-6.01 0-.24 0-.44.04-.68a8.7 8.7 0 0 1 3.56-.762M12 6.01c3.32 0 6 2.684 6 6.01 0 .32-.04.64-.08.961A10.56 10.56 0 0 0 9.6 8.935c-1.04 0-2.04.16-3 .44C7.6 7.372 9.64 6.01 12 6.01"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#fff",
      d: "M12 15.626a.4.4 0 1 1 0 .8.4.4 0 0 1 0-.8m3.2 0a.4.4 0 1 1 0 .8.4.4 0 0 1 0-.8m-1.6-.802a.4.4 0 1 1-.001.802.4.4 0 0 1 0-.802Zm-4-5.89c3.4 0 6.4 1.603 8.32 4.047-.12.681-.32 1.362-.68 1.963-1.48-2.604-4.36-4.367-7.64-4.367-1.28 0-2.48.281-3.56.762a6.2 6.2 0 0 1 .56-1.964c.96-.28 1.96-.44 3-.44Zm0 5.09a.4.4 0 1 1 0 .8.4.4 0 0 1 0-.8m2.4 0a.4.4 0 1 1 0 .8.4.4 0 0 1 0-.8m3.2 0a.4.4 0 1 1 0 .799.4.4 0 0 1 0-.8ZM8 13.221a.4.4 0 1 1 0 .801.4.4 0 0 1 0-.801m0-1.603a.4.4 0 1 1 0 .801.4.4 0 0 1 0-.8Z"
    })]
  }), /*#__PURE__*/_jsx("defs", {
    children: /*#__PURE__*/_jsx("clipPath", {
      id: "a",
      children: /*#__PURE__*/_jsx("path", {
        fill: "#fff",
        d: "M0 0h24v24H0z"
      })
    })
  })]
});
export default SvgBr;